document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const submitBtn = document.getElementById('majik-submit-btn');
    const phoneInput = document.getElementById('subscriber-phone');
    const couponMsg = document.getElementById('coupon-message');

    if (!submitBtn) return;

    submitBtn.addEventListener('click', function() {
      const phone = phoneInput.value.trim();

      // Validate 10-digit mobile number
      if (!/^[6-9]\d{9}$/.test(phone)) {
        alert("Please enter a valid 10-digit mobile number");
        return;
      }

      // Show loading effect
      submitBtn.classList.add('loading');
      submitBtn.innerText = 'PROCESSING...';

      // Submit to Google Form
      const formData = new FormData();
      formData.append('entry.948441746', phone);

      fetch('https://docs.google.com/forms/u/0/d/e/1FAIpQLScug_aiTnBmzIcTu6Yt37OHFpiRndmCLimX7k7l2YGi-k0J0w/formResponse', {
        method: 'POST',
        mode: 'no-cors',
        body: formData
      }).finally(() => {
        // Show coupon message
        couponMsg.innerHTML = `
          <div style="text-align:center; font-size:16px; font-weight:600;">
            Congrats! Your coupon code is: <strong id="coupon-code">MAJIK10</strong>
            <button id="copy-coupon" style="margin-top:8px; padding:6px 12px; border:none; border-radius:8px; background:#e6007e; color:#fff; cursor:pointer;">Copy Coupon</button>
          </div>`;
        couponMsg.style.display = 'block';
        couponMsg.scrollIntoView({behavior: "smooth"});

        // Copy coupon
        const newCopyBtn = document.getElementById('copy-coupon');
        if (newCopyBtn) {
          newCopyBtn.addEventListener('click', function() {
            const code = document.getElementById('coupon-code').innerText;
            navigator.clipboard.writeText(code).then(() => {
              alert("Coupon code copied!");
            });
          });
        }

        // Reset button
        submitBtn.classList.remove('loading');
        submitBtn.innerText = 'GET MY COUPON';
      });
    });
  }, 200);
});
